import fly from '../../../http';
import { UrlType } from '../../constants';
function handleToken(urlType) {
  var _fly$config, _fly$config$extra;
  var accessToken = (_fly$config = fly.config) === null || _fly$config === void 0 ? void 0 : (_fly$config$extra = _fly$config.extra) === null || _fly$config$extra === void 0 ? void 0 : _fly$config$extra.accessToken;
  var opts = {
    headers: {
      urlType: urlType
    }
  };
  if (!!accessToken) {
    opts.headers['SUB-Access-Token'] = accessToken;
  }
  return opts;
}

/**
 * **接口** [获取绑卡列表↗](http://apidoc.inshopline.com/#/project/123/feature%2Fsub_platform/interface/a2a86c58b6920a48c14bf1fd48a1e3d8)
 * @请求头 `GET /api/bill/platform/pay/listBindCard`
 * @更新时间 `2022-02-24 10:02:15`
 */
export function getListBindCard(params) {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/pay/listBindCard", params, opts);
}
/**
 * **接口** [商家已绑定信用卡列表↗](http://apidoc.inshopline.com/#/project/123/dev/interface/9507e35cb2f8d065f9a1dbe52a1fc0b2)
 * @请求头 `GET /api/bill/platform/sl/pay/listMerchantBindCard`
 * @更新时间 `2022-11-14 10:38:40`
 */
export function getListMerchantBindCard() {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/pay/listMerchantBindCard", {}, opts);
}

/**
 * **接口** [创建付费套餐↗](http://apidoc.inshopline.com/#/project/148/master/interface/1370e476181e0715c0efb8cf70fa78c9)
 * @请求头 `POST /sub/create`
 * @更新时间 `2022-02-23 11:33:41`
 */
export function postSubCreate(data) {
  var opts = handleToken(UrlType.SUB);
  return fly.post("/sub/create", data, opts);
}

/**
 * **接口** [获取账单状态↗](http://apidoc.inshopline.com/#/project/123/feature%2Fsub_platform/interface/9081b5bbbd1959ea9625411988ab3565)
 * @请求头 `GET /api/bill/platform/bill/getStatus`
 * @更新时间 `2022-02-22 18:10:32`
 */
export function getBillStatus(params) {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/bill/getStatus", params, opts);
}